// extracted by mini-css-extract-plugin
export default {"container":"Sql5axMdZzbu8fl1B9ZT","list":"lquXDRkiQWUNU4YNhzs6"};